import { isValidDate } from '@cian/utils';

import { EDITORIAL_TIMEZONE } from './moscowDate';

/**
 * Приводит дату к формату DD.MM.YYYY (календарь Москвы — совпадение SSR и клиента).
 */
export const formatDateToDDMMYYYY = (date: Date) =>
  isValidDate(date)
    ? date.toLocaleDateString('ru-RU', {
        timeZone: EDITORIAL_TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
    : '';
